import PageHeading from '../components/common/PageHeading';
import { supportItems } from '../data/siteContent';

function SupportPage() {
  return (
    <section className="page-section" aria-labelledby="support-title">
      <PageHeading
        id="support-title"
        label="고객센터"
        title="궁금한 점은 말타 고객센터로 연결하세요"
        description="서비스 이용, 예약, 파트너 상담에 필요한 공식 문의 채널입니다."
      />
      <div className="support-grid">
        {supportItems.map((item) => (
          <a className="support-card" href={item.href} key={item.title}>
            <div>
              <h2>{item.title}</h2>
              <p>{item.body}</p>
            </div>
            <span>연결</span>
          </a>
        ))}
      </div>
    </section>
  );
}

export default SupportPage;
